import { render, staticRenderFns } from "./AppMessageBox.vue?vue&type=template&id=6529ea7a&"
import script from "./AppMessageBox.vue?vue&type=script&lang=js&"
export * from "./AppMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./AppMessageBox.vue?vue&type=style&index=0&id=6529ea7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports